import React from 'react';
import '../assets/css/home_page_new.css';
import PurchasePlan from '../components/HomePageNew/PurchasePlan';
import EveryCompany from '../components/HomePageNew/EveryCompany';
import FindDentist from '../components/HomePageNew/FindDentist';
import DentalVip from '../components/HomePageNew/DentalVip';
import Footer from '../components/HomePageNew/Footer';
/* import GetSalesmanLinkSite from '../components/HomePageNew/GetSalesmanLinkSite'; */
import Aide from '../components/HomePageNew/Aide';
//import RequestBonus from '../components/HomePageNew/RequestBonus';


const HomePageNew = () => {

  return (
    <div>
      <PurchasePlan/>
      {/*<RequestBonus/>*/}
      <EveryCompany/>
      <FindDentist/>
      <DentalVip/>
      {/*<Contact/> */}
      <Footer/>
      {/* <GetSalesmanLinkSite /> */}
      <Aide />
    </div>
  );
};

export default HomePageNew;



/** WEBPACK FOOTER **
 ** ./src/containers/HomePageNew.js
 **/